module.exports = __webpack_public_path__ + "static/bg_114_my_little_pony-f3930a389c0a5472f748379c17530b35.webp";